module.exports = __webpack_public_path__ + "static/media/bulb.d54515ca.svg";